var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { id: "id-18a", x1: "80.992%", x2: "0%", y1: "92.677%", y2: "-11.554%" },
        React.createElement("stop", { offset: "0%", stopColor: "#498A90" }),
        React.createElement("stop", { offset: "100%", stopColor: "#CBF0F2" })
      )
    ),
    React.createElement("path", { d: "M20 0v5.217C11.836 5.217 5.217 11.836 5.217 20S11.836 34.783 20 34.783c8.07 0 14.63-6.468 14.78-14.502l.003-.281H40c0 11.046-8.954 20-20 20S0 31.046 0 20C0 9.065 8.776.18 19.67.003L20 0z", fill: "url(#id-18a)", fillRule: "evenodd" })
  );
});